<template>
    <div class="c-card-grid">
        <Card
            v-for="card in cards"
            :key="card.title"
            :asset="card.asset"
            :content="card.body"
            v-view.once
        ></Card>
    </div>
</template>

<script>
import Card from 'templates/components/Card';

export default {
    name: 'block-cards',
    components: {
        Card,
    },
    props: {
        cards: {
            type: Array,
        },
    },
};
</script>


<style lang="scss">

    .c-card-grid {
        margin-top: 2em;
        margin-bottom: 2em;

        @screen xs {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            @include grid-breakpoints(grid-row-gap);
            @include grid-breakpoints(grid-column-gap);
        }

        @screen sm {
            grid-template-columns: repeat(3, 1fr);
        }
    }

    .c-card__asset {
        opacity: 0;
        transform: translate(0, 1em) scale(1, .9);
        transform-origin: 50% 100%;
    }

    .c-card__content {
        opacity: 0;
        transform: translate(0, -1em) scale(1, .9);
        transform-origin: 50% 0;
    }

    .c-card {

        &.view-in {
            --transition-delay: 0s;

            .c-card__asset,
            .c-card__content {
                opacity: 1;
                transform: translate(0) scale(1);
                transition: opacity .6s $out-sine var(--transition-delay), transform .6s $out-expo var(--transition-delay);
            }
        }

        @screen xs {

            &:nth-child(2n)     { --transition-delay: .3s; }
        }

        @screen sm {

            &:nth-child(2n)     { --transition-delay: 0s }
            &:nth-child(3n+2)   { --transition-delay: .2s }
            &:nth-child(3n)     { --transition-delay: .4s }
        }
    }

</style>
